const TOKEN_KEY = "token";

export const getStoredToken = () => {
  return sessionStorage.getItem(TOKEN_KEY) || localStorage.getItem(TOKEN_KEY);
};

export const storeToken = (token) => {
  if (!token) return;
  sessionStorage.setItem(TOKEN_KEY, token);
  localStorage.removeItem(TOKEN_KEY);
};

export const clearStoredToken = () => {
  sessionStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(TOKEN_KEY);
};

export const migrateStoredToken = () => {
  const token = getStoredToken();
  if (token) {
    storeToken(token);
  }
  return token;
};
